//import createSwiper from '../utils/swiper';
import Swiper from 'swiper/bundle';
import gsap from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
import pages from './pages';
// Importation de LocomotiveScroll pour utiliser directement l'instance créée
import LocomotiveScroll from 'locomotive-scroll';
import search from "../utils/search";

gsap.registerPlugin(ScrollTrigger);

const accueil = {
    init() {
        pages.init();
        this.initSwipers();
    },

    initSwipers() {

        const swiper = new Swiper(".__partenaires", {
            slidesPerView: 5,
            spaceBetween: 20,
            //centeredSlides: true,
            centeredSlidesBounds: true,
            centerInsufficientSlides: true,
            freeMode: {enabled: true},
            watchOverflow: true,
            grabCursor: true,
            breakpoints: {
                0: {slidesPerView: 1},
                640: {slidesPerView: 1.3},
                768: {slidesPerView: 2},
                992: {slidesPerView: 3},
                1450: {slidesPerView: 4},
            },
            navigation: {
                nextEl: ".evt-next",
                prevEl: ".evt-prev"
            },
        });

    }
};

export default accueil;
